import { createBrowserRouter } from 'react-router-dom'
import { Nav } from '../components/nav'
import { ProtectedRoutes } from './protected-routes'
import { LandingView } from '../views/landing.view'
import { SignUpView } from '../views/signup.view'
import { ConfirmEmailView } from '../views/confirm-email.view'
import { Feedback } from '../views/feedback'
import { LoginView } from '../views/login.view'
import { RecoverAccountView } from '../views/recover-account.view'
import { DashboardView } from '../views/dashboard.view'
import { ProfileView } from '../views/profile.view'
import { ResetPasswordView } from '../views/reset-password.view'
import { SelectNewFormView } from '../views/select-new-form.view'
import { TemplatesView } from '../views/templates'
import { NewFormView } from '../views/new-form.view'
import { FormView } from '../views/form.view'
import { SubmitFormView } from '../views/submit-form.view'
import { ReviewFormView } from '../views/review-form.view'
import { AnalysisView } from '../views/analysis.view'
import { SubmissionView } from '../views/submission.view'
import { PreviewFormView } from '../views/preview-form'
import { TermsView } from '../views/terms.view'
import { PrivacyView } from '../views/privacy.view'

export const router = createBrowserRouter([
  { path: '/sign-up', element: <SignUpView /> },
  { path: '/log-in', element: <LoginView /> },
  {
    path: '/',
    element: <Nav />,
    children: [
      { index: true, element: <LandingView /> },
      { path: 'confirm-email', element: <ConfirmEmailView /> },
      { path: 'experience', element: <Feedback /> },
      { path: 'recover-account', element: <RecoverAccountView /> },
      { path: 'form/new/select', element: <SelectNewFormView /> },
      { path: 'templates', element: <TemplatesView /> },
      { path: 'terms', element: <TermsView /> },
      { path: 'privacy', element: <PrivacyView /> },
      {
        path: 'form/new',
        children: [
          { path: 'edit', element: <NewFormView /> },
          { path: 'preview', element: <PreviewFormView /> }
        ]
      },
      {
        path: 'form/:formId',
        children: [
          { path: 'submit', element: <SubmitFormView /> },
          { path: 'review', element: <ReviewFormView /> },
          { path: 'submission/:submissionId', element: <SubmissionView /> }
        ]
      },
      {
        element: <ProtectedRoutes />,
        children: [
          { path: 'dashboard', element: <DashboardView /> },
          { path: 'profile', element: <ProfileView /> },
          { path: 'reset-password', element: <ResetPasswordView /> },
          {
            path: 'form/:formId',
            children: [
              { index: true, element: <FormView /> },
              { path: 'edit', element: <NewFormView /> },
              { path: 'preview', element: <PreviewFormView /> },
              { path: 'analysis', element: <AnalysisView /> }
            ]
          }
        ]
      }
    ]
  }
])
